import { FC, ReactNode } from "react";
import { motion, AnimatePresence, PanInfo } from "framer-motion";
import { Typography } from "@mui/material";

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  onApply: () => void;
  title: string;
  children: ReactNode;
}

const BottomSheet: FC<BottomSheetProps> = ({
  isOpen,
  onClose,
  onApply,
  title,
  children
}) => {
  const sheetHeight = 550;

  const handleDragEnd = (_: MouseEvent, info: PanInfo) => {
    if (info?.offset?.y > 200) {
      onClose();
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.4 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black z-40"
            onClick={onClose}
          />

          <motion.div
            drag="y"
            dragConstraints={{ top: 0, bottom: 0 }}
            dragElastic={0.2}
            onDragEnd={handleDragEnd}
            dragMomentum={false}
            initial={{ y: sheetHeight }}
            animate={{ y: 0 }}
            exit={{ y: sheetHeight }}
            transition={{ type: "spring", damping: 30, stiffness: 300 }}
            className="fixed bottom-0 left-0 right-0 bg-white rounded-t-[24px] z-50"
            style={{ 
              height: `${sheetHeight}px`,
              touchAction: "none"
            }}
          >
            <div onClick={onClose} className="flex justify-center pt-4 pb-2">
              <div className="w-10 h-1 bg-gray-300 rounded-full" />
            </div>

            <div className="px-6 pb-4 border-b border-gray-200">
              <Typography 
                variant="h6" 
                sx={{ 
                  color: "#0C7878", 
                  fontWeight: "bold" 
                }}
              >
                {title}
              </Typography>
            </div>

            <div className="p-6 overflow-y-auto" style={{ height: 'calc(100% - 100px)' }}>
              {children}
            </div>

            <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200 bg-white">
              <div className="flex gap-3">
                <button
                  className="flex-1 px-4 py-2 bg-gray-100 text-gray-700 rounded-md"
                  onClick={onClose}
                >
                  Cancelar
                </button>
                <button
                  className="flex-1 px-4 py-2 bg-[#0C7878] text-white rounded-md"
                  onClick={onApply}
                >
                  Aplicar
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
};

export default BottomSheet;
